<template>
  <a-spin :spinning="formOption.busy">

    <a-form :form="form"
            :label-col="{ span: 12 }"
            :wrapper-col="{ span: 12 }"
    >

      <div class="form_title">基础设置</div>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="活动标题"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <a-input v-decorator="['actTitle',rules.actTitle]" :maxLength="20"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="活动时间"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 8 }">
            <a-range-picker show-time v-decorator="['actTime',rules.actTime]"
                            :valueFormat="'YYYY-MM-DD HH:mm:ss'"></a-range-picker>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="主办单位"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <a-input v-decorator="['organizer']" :maxLength="20"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="活动规则说明"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <a-textarea v-decorator="['actRule',rules.actRule]" :maxLength="150" :autoSize="true"/>
          </a-form-item>
        </a-col>
      </a-row>
      <div class="form_title">分享信息</div>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="分享标题"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <a-input v-decorator="['shareTitle',rules.shareTitle]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="分享文案"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <a-textarea v-decorator="['shareDescription',rules.shareDescription]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="分享图片"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <uploader :num="1" v-decorator="['shareImg',rules.shareImg]" :accept="'image/*'"
                      :url="api.temp.UPLOAD_PATH"
            ></uploader>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col>
          <a-form-item label="预览图片"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <uploader :num="1" v-decorator="['previewImg',rules.previewImg]" :accept="'image/*'"
                      :url="api.temp.UPLOAD_PATH"
            ></uploader>
          </a-form-item>
        </a-col>
      </a-row>


    </a-form>

    <a-space class="a-form-btn-box">
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" @click="submit">下一步</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import {formMixin, fmt} from '@/utils/common/FormBase'

console.log(fmt)
//厂商用户管理接口
import {dataApi} from "@/services/market/active";


/**
 * 加载规则 必填控制我
 */
function getRulesTemplate() {
  return {
    actTitle: {
      rules: [{required: true, message: "请输入活动名称"}]
    },
    actTime: {
      rules: [{required: true, message: "请选择活动时间"}]
    },
    shareTitle: {
      rules: [{required: true, message: "请输入分享标题"}]
    },
    shareDescription: {
      rules: [{required: true, message: "请输入分享文案"}]
    },
    shareImg: {
      rules: [{required: true, message: "请上传分享图片"}]
    },
    actRule: {
      rules: [{required: true, message: "请输入活动规则"}]
    },
    previewImg: {
      rules: [{required: true, message: "请上传预览图片"}]
    },

  };
}


/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {
    notify: true
  };
}


/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  entity.data.actTime = [entity.data.startDate, entity.data.endDate]
  return fmt.formatFormLoad(entity);
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad(entity) {
  console.log(entity)
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function submit() {
  let entities = null
  this.form.validateFieldsAndScroll((err, values) => {
    if (!err) {//无任何错误 向下执行
      entities = values;
    }
  });
  entities.startDate = entities.actTime[0]
  entities.endDate = entities.actTime[1]
  entities.actId = this.rowId || 0
  entities.elementList = [{
    elementDetail: JSON.stringify(this.url),
    backgroundImg: this.url.bgUrl,
    frontImg: this.url.coverUrl
  }]
  entities.templateId = this.templateId
  await dataApi.saveFormDetail(entities).then(res => {
    if (res.code === 200) {
      this.$emit('nextStep', res.data.actId)
    } else {
      this.$message.error(res.msg)
    }
  })
}

/**
 * 加载基础数据
 */
async function loadBaseData() {
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {},
  props: ['templateId', 'url'],
  data() {
    return {
      actTime: []
    }
  },
  mounted() {
    // 切换页面时滚动条自动滚动到顶部
    window.scrollTo(0, 0);
  },
  methods: {
    loadEntity,
    newEntity,
    submit,
    getRulesTemplate,
    afterLoad,
    loadBaseData,
    cancel() {
      this.$emit('cancel')
    }
  }
};
</script>
